import { transferOwnership, } from "../actions/transferOwnership.js";
export const lightAccountClientActions = (client) => ({
    transferOwnership: async (args) => transferOwnership(client, args),
});
//# sourceMappingURL=lightAccount.js.map